import { useAppDispatch } from './state'
import he from 'he'
import { getAgency as getAgencyAPI, getAgencyPrintout as getAgencyPrintoutAPI } from '../api/agency'
import { setAgency, setAgencyPrintout } from '../state/slices/agency_slice'
import * as Sentry from '@sentry/react'

export const useAgency = () => {
  const dispatch = useAppDispatch()

  const getAgency = async (id: string): Promise<boolean> => {
    try {
      const result = await getAgencyAPI(id)

      if (result.data) {
        const agency = result.data

        // Decode HTML entities in the agency name
        agency.name = he.decode(agency.name)
        // Sort opening hours by dayNumber
        agency.openingHours = agency.openingHours.sort((a, b) => a?.dayNumber - b?.dayNumber)

        dispatch(setAgency(agency))
      }

      return true
    } catch (error) {
      return false
    }
  }

  const getAgencyPrintout = async (id: string): Promise<boolean> => {
    try {
      const result = await getAgencyPrintoutAPI(id)

      if (result.data) {
        dispatch(setAgencyPrintout(result.data))
      }

      return true
    } catch (error) {
      Sentry.captureException(error)

      return false
    }
  }

  return {
    getAgency,
    getAgencyPrintout
  }
}

export default useAgency
